<template>
    <div v-if="mapProvider == '必应地图' ">
      <vc-layer-imagery >
        <vc-imagery-provider-bing
          :map-style="mapStyle"
          bm-key="AmGu3cvB_g1HbkQErEyvmLc9j0YIGWS7IdOqR7-hQbO8J92Fzrzkhy_bYKSsyoEx"
          :projection-transforms="{ form: 'GCJ02', to: 'WGS84' }"
          ref="providerBing"
        ></vc-imagery-provider-bing>
      </vc-layer-imagery>
    </div>
</template>

<script>
import { toRaw } from 'vue';
export default {
    name:'ProviderBing',
    props:['mapProvider','defaultProvider'],
    
    data(){
        return {
            mapStyle:'',
            mapProvider:'',
            mapOptions : [
            {
                value: 'Aerial',
                label: '卫星图'
            },
            {
                value: 'AerialWithLabels',
                label: '卫星图(标签)'
            },
            {
                value: 'Road',
                label: '道路图'
            },
            {
                value: 'CanvasDark',
                label: '黑夜风格'
            }
            ],

        }
    },
    // watch:{
    //     mapProvider:{
    //         handler(newVal , oldVal){
    //             if(newVal !== "必应地图" && this.$refs.providerBing){
    //                 this.$refs.providerBing.unload();
    //             }else if(newVal == "必应地图"){
    //                 console.log("必应Options:",this.mapOptions)
    //                 this.$bus.emit('getMapOptions',toRaw(this.mapOptions));
    //             }
    //         }
    //     }
    // },
    methods:{
        getMapStyle(mapStyle){
            this.mapStyle = mapStyle;
        },
        getMapArray(currentMap){
            if(currentMap !== "必应地图" && this.$refs.providerBaidu){
            this.$refs.providerBaidu.unload();
            }else if(currentMap == "必应地图"){
                console.log("必应Options:",this.mapOptions)
                this.mapProvider = currentMap ;
                this.$bus.emit('getMapOptions',toRaw(this.mapOptions));
                // this.mapStyle = this.mapOptions[0].value ;
            }
        }
    },
    mounted(){
        if(this.defaultProvider){
            console.log("必应Options:",this.mapOptions)
            this.$bus.emit('getMapOptions',toRaw(this.mapOptions));
        }
        this.$bus.on('getMapStyle',this.getMapStyle);
        this.$bus.on('getMapArray',this.getMapArray);
        this.$bus.on("getCurrentMap",this.getMapArray);
    },
    beforeUnmount() {
        this.$bus.all.clear();
    },
}
</script>

<style>

</style>